/**
 * Date helpers utilities
 * Additional date operations beyond formatters
 */

/**
 * Calculate expiry date from start date and months
 */
export function calculateExpiryDate(
    startDate: string | Date,
    months: number = 1
): string {
    const date = typeof startDate === 'string' ? new Date(startDate) : startDate;
    date.setMonth(date.getMonth() + months);
    return date.toISOString();
}

/**
 * Check if date has expired
 */
export function isExpired(date: string | Date): boolean {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d < new Date();
}

/**
 * Calculate days between two dates
 */
export function daysBetween(date1: string | Date, date2: string | Date): number {
    const d1 = typeof date1 === 'string' ? new Date(date1) : date1;
    const d2 = typeof date2 === 'string' ? new Date(date2) : date2;
    const diff = Math.abs(d2.getTime() - d1.getTime());
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

/**
 * Check if date is within last N days
 */
export function isWithinLastDays(date: string | Date, days: number): boolean {
    const d = typeof date === 'string' ? new Date(date) : date;
    const now = new Date();
    const diff = (now.getTime() - d.getTime()) / (1000 * 60 * 60 * 24);
    return diff <= days;
}

/**
 * Add days to a date
 */
export function addDays(date: string | Date, days: number): string {
    const d = typeof date === 'string' ? new Date(date) : date;
    d.setDate(d.getDate() + days);
    return d.toISOString();
}

/**
 * Get start of day
 */
export function startOfDay(date: string | Date): Date {
    const d = typeof date === 'string' ? new Date(date) : date;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * Get end of day
 */
export function endOfDay(date: string | Date): Date {
    const d = typeof date === 'string' ? new Date(date) : date;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
}

/**
 * Get start of month
 */
export function startOfMonth(date: string | Date): Date {
    const d = typeof date === 'string' ? new Date(date) : date;
    return new Date(d.getFullYear(), d.getMonth(), 1);
}

/**
 * Get end of month
 */
export function endOfMonth(date: string | Date): Date {
    const d = typeof date === 'string' ? new Date(date) : date;
    return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
}
